import { Component, OnInit, OnDestroy, Renderer2 } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { LoginService } from 'src/app/services/login/login.service';
import { Router } from '@angular/router';
import { ICerberusToken } from 'src/app/interfaces/icerberus-token/icerberus-token.interface';
import { environment as LOCAL_ENV } from 'src/environments/environment.local';
import { environment as DEV_ENV } from 'src/environments/environment.dev';
import { environment as UAT_ENV } from 'src/environments/environment.uat';
import { environment as PROD_ENV } from 'src/environments/environment.prod';
import { Store } from '@ngrx/store';
import { GetOrganisationsAction, SetEnvironmentAction } from 'src/app/store/global/global.actions';
import { State } from 'src/app/store';
import { catchError, takeUntil, tap } from 'rxjs/operators';
import { Subject } from 'rxjs';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit, OnDestroy {
    private destroy$ = new Subject();

    public loginForm: FormGroup;
    public isAuthLoading = false;

    public environments = [
        {
            label: 'LOCAL',
            baseUrl: LOCAL_ENV.API_GATEWAY_URL,
        },
        {
            label: 'DEV',
            baseUrl: DEV_ENV.API_GATEWAY_URL,
        },
        {
            label: 'UAT',
            baseUrl: UAT_ENV.API_GATEWAY_URL,
        },
        {
            label: 'PROD',
            baseUrl: PROD_ENV.API_GATEWAY_URL,
        },
    ];

    constructor(private router: Router, private renderer: Renderer2, private toastr: ToastrService, private loginService: LoginService, private store: Store<State>) {}

    ngOnInit() {
        this.renderer.addClass(document.querySelector('app-root'), 'login-page');
        this.loginForm = new FormGroup(
            {
                email: new FormControl(null, Validators.required),
                password: new FormControl(null, Validators.required),
                env: new FormControl(null, Validators.required),
            },
            {
                updateOn: 'change',
            },
        );
    }

    async login() {
        if (this.loginForm.valid) {
            this.loginService
                .login(this.email.value, this.password.value)
                .pipe(
                    takeUntil(this.destroy$),
                    catchError((e) => {
                        console.log(e);
                        return null;
                    }),
                    tap((token: ICerberusToken) => {
                        if (token) {
                            localStorage.setItem('token', token.accessToken);
                            localStorage.setItem('cerberus-env', JSON.stringify(this.env.value));

                            this.store.dispatch(GetOrganisationsAction());

                            this.router.navigate(['/']);
                        }
                    }),
                )
                .subscribe();
        } else {
            this.toastr.error('Hello world!', 'Toastr fun!');
        }
    }

    selectEnv($event) {
        this.store.dispatch(
            SetEnvironmentAction({
                environment: {
                    label: $event.label,
                    baseUrl: $event.baseUrl,
                },
            }),
        );
    }

    ngOnDestroy() {
        this.renderer.removeClass(document.querySelector('app-root'), 'login-page');
        this.destroy$.next();
        this.destroy$.complete();
    }

    get email() {
        return this.loginForm.get('email');
    }
    get password() {
        return this.loginForm.get('password');
    }

    get env() {
        return this.loginForm.get('env');
    }
}
